import {
  Box,
  Disclaimer,
  Div,
  H3,
  displayCentsInDollars,
  lightTheme,
} from '@vgrubs/components';

type Props = {
  totals: {
    totalCount: number;
    inProgressCount: number;
    rewardedCount: number;
    totalPaidOut: number;
  };
};

/**
 * The program at a glance. These are the whole program's numbers whatever tab
 * or search is on, which is why the hints say what they count rather than
 * echo the filter.
 */
export const ReferralSummaryCards = ({ totals }: Props) => {
  const cards = [
    {
      label: 'Referrals',
      value: String(totals.totalCount),
      hint: 'Restaurants brought in by restaurants',
    },
    {
      label: 'In progress',
      value: String(totals.inProgressCount),
      hint: 'Signed up or counting orders',
    },
    {
      label: 'Earned',
      value: String(totals.rewardedCount),
      hint: 'Both bonuses paid',
    },
    {
      label: 'Paid out',
      value: displayCentsInDollars(totals.totalPaidOut),
      color: lightTheme.green,
      hint: 'Both sides together',
    },
  ];

  return (
    <Div
      $grid
      $gridTemplateColumns="repeat(4, minmax(0, 1fr))"
      $gridTemplateColumnsSM="repeat(2, minmax(0, 1fr))"
      $gap="16px"
      $gapSM="8px"
    >
      {cards.map((card) => (
        <Box key={card.label} $flex $column $gap="4px">
          <Disclaimer $m="0">{card.label}</Disclaimer>
          <H3 $m="0" $color={card.color}>
            {card.value}
          </H3>
          <Disclaimer $m="0" $color={lightTheme.lightGray}>
            {card.hint}
          </Disclaimer>
        </Box>
      ))}
    </Div>
  );
};
